import React from 'react';
import { Youtube, Video, FileText, Presentation, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

function MaterialsPage() {
  const { language } = useLanguage();
  const t = translations[language];

  const allMaterials = [
    {
      title: 'Novedades IA: Marketing y Audiovisual',
      type: 'Youtube',
      thumbnail: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&q=80&w=400',
      icon: Youtube,
      link: 'https://youtube.com/watch?v=example1',
      date: '2024'
    },
    {
      title: 'Inteligencia Artificial en la Empresa',
      type: 'Presentación',
      thumbnail: 'https://images.unsplash.com/photo-1557426272-fc759fdf7a8d?auto=format&fit=crop&q=80&w=400',
      icon: Presentation,
      link: 'https://slideshare.net/example',
      date: '2024'
    },
    {
      title: 'Introducción a ChatGPT',
      type: 'Video',
      thumbnail: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&q=80&w=400',
      icon: Video,
      link: 'https://youtube.com/watch?v=example2',
      date: '2023'
    },
    {
      title: 'Guía Práctica de Prompting',
      type: 'Documento',
      thumbnail: 'https://images.unsplash.com/photo-1664447972779-316251bd8bd7?auto=format&fit=crop&q=80&w=400',
      icon: FileText,
      link: 'https://example.com/guide.pdf',
      date: '2023'
    },
    {
      title: 'Machine Learning Básico',
      type: 'Video',
      thumbnail: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&q=80&w=400',
      icon: Video,
      link: 'https://youtube.com/watch?v=example3',
      date: '2024'
    },
    {
      title: 'Casos de Éxito IA',
      type: 'Presentación',
      thumbnail: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=400',
      icon: Presentation,
      link: 'https://slideshare.net/example2',
      date: '2024'
    },
    {
      title: 'Retos y Oportunidades en IA',
      type: 'Documento',
      thumbnail: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&q=80&w=400',
      icon: FileText,
      link: 'https://example.com/guide2.pdf',
      date: '2024'
    },
    {
      title: 'Workshop IA Generativa',
      type: 'Video',
      thumbnail: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&q=80&w=400',
      icon: Video,
      link: 'https://youtube.com/watch?v=example4',
      date: '2024'
    }
  ];

  return (
    <>
      <Header />
      <main className="pt-24 pb-20 min-h-screen bg-gradient-to-br from-cyan-50 via-white to-purple-50">
        <div className="container mx-auto px-6">
          <Link 
            to="/" 
            className="inline-flex items-center text-cyan-600 hover:text-purple-600 transition-colors mb-8"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            {t.materials.backToHome}
          </Link>
          
          <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-cyan-500 to-purple-600 bg-clip-text text-transparent">
            {t.materials.title}
          </h1>
          <p className="text-xl text-gray-600 mb-12">
            {t.materials.subtitle}
          </p>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {allMaterials.map((item, index) => (
              <a
                key={index}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative overflow-hidden rounded-xl bg-white shadow-md hover:shadow-xl transition-all duration-300"
              >
                <div className="aspect-video w-full overflow-hidden">
                  <img
                    src={item.thumbnail}
                    alt={item.title}
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4 text-white transform translate-y-0 group-hover:translate-y-0 transition-transform">
                  <div className="flex items-center gap-2 mb-2">
                    <item.icon className="w-5 h-5" />
                    <span className="text-sm font-medium">{item.type}</span>
                  </div>
                  <h3 className="text-lg font-semibold mb-1">{item.title}</h3>
                  <p className="text-sm opacity-90">{item.date}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </main>
    </>
  );
}

export default MaterialsPage;